import React from "react";
import { CheckCircle, XCircle } from "lucide-react";

const AssessmentResult = ({ score=7, totalQuestions=10, onContinue, show }) => {
  if (!show) return null;

  const percentage = Math.round((score / totalQuestions) * 100);
  const passed = percentage >= 60;


  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 1100,
      }}
    >
      <style>{`
        .assessment-result-continue-btn { transition: filter 0.2s; }
        .assessment-result-continue-btn:hover { filter: brightness(0.9); }
      `}</style>
      <div
        className="bg-white rounded-3 shadow-lg overflow-hidden"
        style={{ width: "100%", maxWidth: "420px", margin: "0 16px" }}
      >
        {/* Header */}
        <div className="border-bottom px-4 py-3">
          <h5 className="fw-bold text-center mb-0">Assessment Results</h5>
        </div>

        {/* Body */}
        <div className="text-center px-4 py-5">
          {/* Score Circle */}
          <div
            className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
            style={{
              width: "100px",
              height: "100px",
              border: `4px solid ${passed ? "#198754" : "#ea580c"}`,
              backgroundColor: passed ? "#f0fdf4" : "#fff7ed",
            }}
          >
            <span
              className="fw-bold"
              style={{ fontSize: "28px", color: passed ? "#198754" : "#ea580c" }}
            >
              {percentage}%
            </span>
          </div>

          {/* Icon */}
          {/* <div className="mb-3">
            {passed ? (
              <CheckCircle size={32} color="#198754" />
            ) : (
              <XCircle size={32} color="#ea580c" />
            )}
          </div> */}

          {/* Score Text */}
          <p className="fw-semibold fs-6 text-dark mb-1">
            You scored {score} out of {totalQuestions}
          </p>
          <p className="text-muted" style={{ fontSize: "13px" }}>
            {passed
              ? "Great job! Your application will be processed."
              : "Thank you for your effort."}
          </p>
        </div>

        {/* Footer */}
        <div
          className="border-top px-4 py-3 d-flex justify-content-center"
          style={{ backgroundColor: "#F3F5F9" }}
        >
          <button
            className="btn assessment-result-continue-btn"
            onClick={onContinue}
            style={{
              backgroundColor: "#081DA5",
              borderColor: "#081DA5",
              color: "#fff",
              fontWeight: 600,
              padding: "0.375rem 1.5rem",
              borderRadius: "8px",
              boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssessmentResult;